import Simulator from "../../deprecated/simulators/Simulator";

var SIMULATOR = {
    ID_DEFAULT_CONTENT : "simulator_default",
    ID_DPI : "dpiWrapper",
    ID_MOSAIC_WRAPPER_SIMULATOR: "simulator_container"
};

function displayDefaultContent() {
    // append default content - DCW-2155
    var simulatorWrapperApi = document.getElementById(SIMULATOR.ID_DPI);
    var simulatorContainer = document.getElementById(SIMULATOR.ID_MOSAIC_WRAPPER_SIMULATOR);
    var defaultContent = document.getElementById(SIMULATOR.ID_DEFAULT_CONTENT);

    // hide container of simulator to avoid coming of simulator too late or the presence of the loader from API
    simulatorWrapperApi.classList.add('dcw_visually-hidden');

    // check if container exists
    if (!simulatorContainer) {
        throw new Error("SimulatorPPI - dpiAwtConfig is not defined && no container available");
    }

    // check if default content container exists
    if (!defaultContent) {
        throw new Error("SimulatorPPI - default content is not set");
    }

    // check if default content container has content
    if (!defaultContent.children) {
        throw new Error("SimulatorPPI - default content is empty");
    }

    // display default content
    simulatorContainer.appendChild(defaultContent.children[0]);
}

function SimulatorPPI(options) {
    if (!this._isDpiDefined()) {
        displayDefaultContent();
    }

    Simulator.call(this, options);
    this.integrationMode = this._getIntegrationMode();
}

SimulatorPPI.prototype = Object.create(Simulator.prototype);
SimulatorPPI.prototype.constructor = SimulatorPPI;

SimulatorPPI.prototype._getIntegrationMode = function () {
    var integrationModeValue = this.element.getAttribute(
        "data-clientside-integration-mode"
    );

    if (!integrationModeValue || integrationModeValue === "empty") {
        return "";
    } else {
        return integrationModeValue;
    }
};

SimulatorPPI.prototype.load = function () {
    if (!window.dpiAwtConfig) {
        return;
    }

    window.ppiSimulator = new window.dpiAwtConfig(
        "dpi",
        null,
        this._buildOptions()
    );

    var timeOutOn = setTimeout(function(){
        displayDefaultContent();
        }, 5000
    );

    window.ppiSimulator.load({},
        function() {
            // if the call success, stop the timer
            clearTimeout(timeOutOn);
        }
    );
};

SimulatorPPI.prototype._buildOptions = function () {
    this.options.integrationMode = this.integrationMode;
    return this.options;
};

SimulatorPPI.prototype._isDpiDefined = function () {
    return !!window.dpiAwtConfig;
};

export default SimulatorPPI;



// WEBPACK FOOTER //
// ./src/js/cms/commons/clientCustomizer/SimulatorPPI.js